var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
    _c("path", { attrs: { d: "M0 0h29v29H0z" } }),
    _vm._v(" "),
    _c("path", {
      attrs: {
        d: "M18.856 29.185a23.88 23.88 0 0011.057 11.006c.716.34 1.559.276 2.216-.168l7.088-4.726a2.265 2.265 0 012.148-.197l13.26 5.683a2.257 2.257 0 011.359 2.348A13.591 13.591 0 0142.502 55C21.238 55 4 37.762 4 16.498 4 9.658 9.084 3.884 15.869 3.016a2.257 2.257 0 012.348 1.359l5.688 13.271a2.265 2.265 0 01-.186 2.133l-4.71 7.196a2.245 2.245 0 00-.153 2.21z",
        stroke: "#000",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }